import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../utils/axios";
import { reduce, map, set, differenceWith, uniqBy } from "lodash";
const initialState = {
  data: null,
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchItemStreamingWindowDataApi = createAsyncThunk(
  "itemStreamingWindowData/fetchItemStreamingWindowDataApi",
  async ({ id }) => {
    const response = await axiosInstance.request({
      url: `sm/streaming/window/${id}`,
      method: "GET",
    });
    return response;
  }
);

const itemStreamingWindowDataSlice = createSlice({
  name: "itemStreamingWindowData",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchItemStreamingWindowDataApi.pending, (state) => {
        set(state, "loading", true);
        set(state, "data", null);
      })
      .addCase(fetchItemStreamingWindowDataApi.fulfilled, (state, action) => {
        set(state, "completed", true);
        set(state, "data", action?.payload?.data || null);
        set(state, "loading", false);
      })
      .addCase(fetchItemStreamingWindowDataApi.rejected, (state, action) => {
        set(state, "completed", true);
        set(state, "loading", false);
        set(state, "hasError", true);
        set(state, "message", action?.error?.message || "");
      });
  },
});

const itemStreamingWindowDataReducer = itemStreamingWindowDataSlice.reducer;

export default itemStreamingWindowDataReducer;

export const itemStreamingWindowDataActions = itemStreamingWindowDataSlice.actions;
